import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";  
import store from "./redux/store.js";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import Root from './routes/Routes.dev';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/_Font.scss';
import './_index.scss';
import './assets/css/_Responsive.scss';

window.Buffer = window.Buffer || require("buffer").Buffer;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Root />
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
